import { render } from "./LocationSection.vue?vue&type=template&id=624632b2&scoped=true"
import script from "./LocationSection.vue?vue&type=script&lang=js"
export * from "./LocationSection.vue?vue&type=script&lang=js"

import "./LocationSection.vue?vue&type=style&index=0&id=624632b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624632b2"]])

export default __exports__